import React, { Component } from "react";
import { HorizontalLoader } from "./Loader";
import "../../../assets/scss/overlay.scss";

class ScreenOverlay extends Component {
    render() {
        return <div className={`overlay ${this.props.show ? "show" : "hide"}`}>
            {this.props.children}
        </div>;
    }
};

export const ScreenOverlayContent = ({ children }) => <div className="overlay-content">{children}</div>;
export const ScreenOverlayText = ({ children }) => <div className="overlay-text">{children}</div>;

ScreenOverlay.Content = ScreenOverlayContent;
ScreenOverlay.Text = ScreenOverlayText;

export const ScreenOverlayLoader = ({ show, text }) =>
    <ScreenOverlay show={show}>
        <ScreenOverlay.Content>
            <ScreenOverlay.Text>{text ? text : 'Saving...'}</ScreenOverlay.Text>
            <HorizontalLoader />
        </ScreenOverlay.Content>
    </ScreenOverlay>;

export default ScreenOverlay;